<template>
  <div>
    <div v-if="showCheckBox" class="check_up_secret">
      <van-checkbox v-model="checked" checked-color="#1a81cf" shape="square" icon-size="16px"  @change="handleChange">
        <span class="secret_text_font">我已阅读并同意</span>
        <span class="secret_text_style secret_text_font" @click.stop="handleClickSecretPolicy">{{ policyTitle }}</span>
      </van-checkbox>
    </div>
    <van-popup v-model="showSecretPolicy" :closeable="showCheckBox" position="left" close-icon-position="top-left" :style="{ height: '100%', width: '100%' }" @close="handleCloseSecretPolicy">
      <div class="secret-content-box">
        <div class="secret-policy-content" v-html="policyContent"></div>

        <div class="next-step-btn-box no-padding-top">
          <div class="next-step-checkbox">
            <van-checkbox v-model="checked" checked-color="#1a81cf" shape="square" icon-size="16px" @change="handleChange">
              <span class="secret_text_font">我已阅读并同意</span>
              <span class="secret_text_style secret_text_font">{{ policyTitle }}</span>
            </van-checkbox>
          </div>
          <div class="btn bigger-btn">
            <van-button :disabled="submitBtnDisabled" class="up" @click="confirmPolicy">{{ btnText }}</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'PolicyPopup',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    policyContent: {
      type: String,
      default: ''
    },
    showCheckBox: {
      type: Boolean,
      default: true
    }
  },
  emits: ['input', 'confirm-policy', 'click-policy-text'],
  data() {
    return {
      checked: false,
      showSecretPolicy: false,
      submitBtnDisabled: false,
      policyTitle: '《隐私政策》',
      btnText: '下一步'
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        this.checked = newVal
      },
      immediate: true
    }
  },
  methods: {
    openPolicyPopup() {
      this.btnText = '下一步'
      this.showSecretPolicy = true
      this.$emit('has-read')
    },
    closePolicyPopup() {
      this.showSecretPolicy = false
    },
    //点击
    handleClickSecretPolicy() {
      this.btnText = '关闭'
      this.showSecretPolicy = true
      this.$emit('has-read')
    },

    //关闭法律声明及隐私协议弹出层事件处理
    handleCloseSecretPolicy() {
      this.showSecretPolicy = false
    },
    handleChange(value) {
      console.log('value', value)
      this.$emit('input', value)
    },
    confirmPolicy() {
      if (this.btnText === '关闭') {
        this.closePolicyPopup()
        return
      }
      if (!this.checked) {
        this.$toast(`请勾选“我已阅读并同意${this.policyTitle}”`)
        return
      }
      this.$emit('confirm-policy')
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
  color: #1a81cf;
}
.secret_text_style {
  font-weight: 500;
  color: #1a81cf;
}
.secret_text_font {
  font-size: 14px;
}
.check_up_secret {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
.secret-content-box {
  padding: 0 16px 16px;
  .secret-policy-content {
    padding-top: 40px;
  }
  .next-step-btn-box {
    padding: 52px 0 0;
    .next-step-checkbox {
      display: flex;
      justify-content: center;
      font-size: 12px;
    }
    .btn {
      margin-top: 31px;
      padding: 0 85px;
      min-height: auto;
      border-top: none;
      .up {
        height: 30px;
      }
    }
    .bigger-btn {
      .up {
        height: 44px;
      }
    }
  }
  .no-padding-top {
    padding-top: 0;
  }
}
</style>
